<script setup lang="ts">
/**
 * @deprecated Duplicate of LocalIcon
 */
import { computed } from 'vue';
import { cva } from 'class-variance-authority';
import LocalIcon from './LocalIcon.vue';

export type CircleIconVariant =
  | 'brand'
  | 'success'
  | 'error'
  | 'warning'
  | 'gray'
  | 'pink'
  | 'white';

export type CircleIconSize = 'small' | 'medium';

export type CircleIconProps = {
  iconName?: string;
  imgSrc?: string;
  imgAlt?: string;
  variant?: CircleIconVariant;
  size?: CircleIconSize;
  class?: string;
};

const props = withDefaults(defineProps<CircleIconProps>(), {
  variant: 'brand',
  size: 'medium',
});

const circleIcon = cva('rounded-full flex items-center justify-center shrink-0', {
  variants: {
    variant: {
      brand: 'bg-blue-100 text-brand-solid',
      success: 'bg-success text-success-primary',
      error: 'bg-error-primary text-error-primary',
      warning: 'bg-warning-primary text-warning-primary',
      gray: 'bg-grey-50 text-grey-700',
      pink: 'bg-pink-50 text-pink-700',
      white: 'bg-white text-grey-700',
    },
    size: {
      small: 'w-8 h-8',
      medium: 'w-12 h-12',
    },
  },
  defaultVariants: {
    variant: 'brand',
    size: 'medium',
  },
});

const iconSize = computed(() => (props.size === 'small' ? 'small' : 'large'));
const classes = computed(() => circleIcon({ variant: props.variant, size: props.size }));
</script>

<template>
  <div :class="[classes, props.class]">
    <img
      v-if="imgSrc"
      :src="imgSrc"
      :alt="imgAlt"
      :class="size === 'small' ? 'w-4 h-4 object-contain' : 'w-8 h-8 object-contain'"
    />
    <LocalIcon v-else-if="iconName" :name="iconName" :size="iconSize" />
  </div>
</template>
